<div
  class="relative-container uv-container"
  (mouseenter)="showClear = true"
  (mouseleave)="showClear = false"
>
  <div class="right clear-padding">
    <a
      *ngIf="!disableClear && editable && showClear && !disableValue"
      class="uv-clear"
      (click)="onClearUnitValue()"
      >{{ "PROJECT.COMMON.CLEAR" | anessaTranslation : trigger }}</a
    >
    <a *ngIf="!showClear"></a>
  </div>
  <div
    *ngIf="modelUnits && _unitValue"
    class="uv"
    [ngClass]="{
      whiteBox: styleWhiteBoxes,
      'white-box-padding': autofilled,
      'uv-column': flexStyle === 'column',
      'label-row': flexStyle !== 'column'
    }"
  >
    <div
      *ngIf="label"
      class="uv-label edit-heading"
      [ngStyle]="{
        flex: labelwidth,
        'font-size': labelFontSize ? labelFontSize : ''
      }"
      [ngClass]="{
        'row-label-space': flexStyle !== 'column'
      }"
    >
      <span
        [matTooltip]="labelTooltip"
        [ngClass]="{
          labelTooltip: labelTooltip !== '' && labelTooltip !== null
        }"
      >
        {{ label }}
      </span>
    </div>
    <mat-form-field
      *ngIf="_unitValue && !unitOnly"
      floatLabel="never"
      class="uv-value"
      [ngClass]="{
        'uv-unit-min-width': uvUnitMinWidth,
        'mat-form-field-invalid': forceInvalid,
        'color-blue': inputsColorStyle.value.anessa_dark_blue,
        'color-anessa-blue': inputsColorStyle.value.anessa_blue,
        'color-anessa-green': inputsColorStyle.value.anessa_green,
        'warning-hint': !errorMessage && warningMessage
      }"
      [ngStyle]="{
        flex: inputwidth,
        'font-size': fontSize ? fontSize : ''
      }"
    >
      <input
        [id]="name + '_input'"
        matInput
        #value="ngModel"
        [name]="valueName"
        [type]="type"
        [required]="required"
        [disabled]="!editable || disableValue"
        [(ngModel)]="valueDisplay"
        (blur)="addCommas()"
        [placeholder]="inputPlaceholder"
        (focus)="removeCommas()"
        appValidateUnitValue
        [unitValue]="_unitValue"
        [preventDashValues]="enableDashValidation"
        [preventNanValues]="enableNanValidation"
        [preventNegativeValues]="enableNegativeValidation"
        [preventNonWholeValues]="enableWholeNumberValidation"
        [preventPercentValues]="enablePercentValidation"
        [preventZeroValues]="enableZeroValidation"
        [greaterThanValue]="greaterThanValue"
        [lessThanValue]="lessThanValue"
        [setCustomErrorMessage]="customErrorMessage"
        [setCustomWarningMessage]="customWarningMessage"
        (errorMessageUpdated)="updateValueValidity()"
        (ngModelChange)="valueChanged($event)"
        (errorMessageUpdate)="updateErrorMessage($event)"
        (warningMessageUpdate)="updateWarningMessage($event)"
        (validationUpdated)="touchValueControl()"
        [validationID]="validationID !== '' ? validationID : name"
      />
      <mat-hint *ngIf="!warningMessage">{{ getAutofilledMessage() }}</mat-hint>
      <mat-hint *ngIf="warningMessage" class="warning-hint">{{ warningMessage }}</mat-hint>
      <mat-error [innerHTML]="errorMessage">
        <!--
        {{ errorMessage }}
-->
      </mat-error>
    </mat-form-field>
    <div
      #valueInput
      *ngIf="modelUnits.length === 1"
      class="uv-unit uv-single-unit"
      [ngStyle]="{
        flex: 0,
        'font-size': fontSize ? fontSize : ''
      }"
      [ngClass]="{
        'color-blue': inputsColorStyle.unit.anessa_dark_blue,
        'color-anessa-blue': inputsColorStyle.unit.anessa_blue
      }"
      [disabled]="disableUnit"
      [innerHTML]="getDisplayName(modelUnits[0])"
      readonly
    ></div>
    <mat-form-field
      *ngIf="modelUnits.length != 1"
      floatLabel="never"
      class="uv-unit"
      [ngStyle]="{
        flex: unitwidth,
        'font-size': fontSize ? fontSize : ''
      }"
      [ngClass]="{
        'color-blue': inputsColorStyle.unit.anessa_dark_blue,
        'color-anessa-blue': inputsColorStyle.unit.anessa_blue
      }"
    >
      <mat-select
        [id]="name + '_select'"
        [placeholder]="dropdownPlaceholder"
        [name]="unitName"
        [required]="required"
        [disabled]="(!editable && !enableConversions) || disableUnit"
        [(ngModel)]="_unitValue.unit"
        (selectionChange)="touched()"
        (ngModelChange)="onUnitChanged(); updateValueValidity()"
        [ngStyle]="{ 'opacity': adjustOpacityOnDisable && !editable ? 0.7 : 1 }"
        [panelClass]="panelClass"
      >
        <mat-select-trigger
          [ngClass]="{
            'color-blue': inputsColorStyle.unit.anessa_dark_blue,
            'color-anessa-blue': inputsColorStyle.unit.anessa_blue
          }"
          [innerHTML]="getSelectedUnitDisplayName(_unitValue.unit)"
        >
        </mat-select-trigger>
        <mat-option *ngFor="let unit of modelUnits" [value]="unit.id">
          <div [innerHTML]="getDisplayName(unit)"></div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
